import { useRef, useEffect } from "react";
import {
  PropertySelect,
  PackageSelect,
  ForestManagementPlan,
  OrderSummary,
} from "../sections";

export default function Order({ disableNextButton }) {
  const propertySelectRef = useRef(null);

  useEffect(() => {
    const propertyObserver = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          // When the user has scrolled passed property select, enable the next button
          !entry.isIntersecting && disableNextButton(false);
        }),
      {
        threshold: 0.4, // 0% threshold to trigger when package select is visible
      }
    );

    if (propertySelectRef.current) {
      propertyObserver.observe(propertySelectRef.current);
    }

    return () => {
      if (propertySelectRef.current) {
        propertyObserver.unobserve(propertySelectRef.current);
      }
    };
  }, []);

  return (
    <div className="flex flex-col w-full gap-8">
      <div ref={propertySelectRef}>
        <PropertySelect />
      </div>
      <div className="w-full h-[0.5px] border border-stone-500/17" />
        <PackageSelect />
        <div className="w-full h-[0.5px] border border-stone-500/17" />
        <ForestManagementPlan />
      <div className="w-full h-[0.5px] border border-stone-500/17" />
      <OrderSummary />
    </div>
  );
}
